import { getGeneratedViewList } from "apiClient/v2/bims/bimViewApi";
import { View } from "apiClient/v2/forgeApi";
import { FamilyInstanceDTO } from "interfaces/dtos/familyInstance";
import { Space } from "interfaces/models/area";
import BimView from "interfaces/models/bimView";
import { DataProjectModel } from "interfaces/models/dataProjectModel";
import { ForgeDataType } from "interfaces/models/generateData";
import ImportFactory from "libs/forge-data/importer/ImporterFactory";
import { GenerateForgeDataHelper } from "utils/generateForgeData";

export const getDataFamilyInstance = async ({
  bimFileId,
  version,
  shouldCache,
  level,
}: {
  bimFileId: string;
  version?: string;
  level?: string;
  shouldCache?: boolean;
}): Promise<{ [externalId: string]: FamilyInstanceDTO } | undefined> => {
  if (!version) {
    return;
  }
  const urn = GenerateForgeDataHelper.getUrn({
    bimFileId,
    version,
  });

  const importer = ImportFactory.createImporter(
    ForgeDataType.FAMILY_INSTANCE_POSITION,
    {
      urn,
      shouldCache,
      ...{ ...(level && { level }) },
    }
  );
  const result = await importer.importData();

  return result?.data;
};

export const getDataSpace = async ({
  bimFileId,
  version,
  shouldCache,
  level,
}: {
  bimFileId: string;
  version?: string;
  level?: string;
  shouldCache?: boolean;
}): Promise<Space[] | undefined> => {
  if (!version) {
    return;
  }
  const urn = GenerateForgeDataHelper.getUrn({
    bimFileId,
    version,
  });

  const importer = ImportFactory.createImporter(ForgeDataType.SPACE, {
    urn,
    shouldCache,
    ...{ ...(level && { level }) },
  });

  const result = await importer.importData();

  return result?.data ?? [];
};

export const getInstanceTableName = ({
  bimFileId,
  version,
}: {
  bimFileId: string;
  version: string;
}) => {
  return `${decodeURIComponent(bimFileId)
    .toLowerCase()
    .replace(/[:.,/-]/g, "_")}_v${version}`;
};

export const checkHaveViewData = async (
  bimId: string,
  version: string,
  views: View[]
) => {
  const urn = `${bimId}?version=${version}`;
  const bimFileId = encodeURIComponent(urn);
  const viewListResponse = await getGeneratedViewList(bimFileId);
  const viewList = viewListResponse?.data || [];

  return checkIsGenerateViewDone(views, viewList);
};

export const checkIsGenerateViewDone = (
  views: View[],
  bimViewList: BimView[]
) => {
  return views.every((v) => {
    return bimViewList.some(
      (vl) => vl.viewId === v.guid && vl.imageUrl && vl.viewData
    );
  });
};

export const getFamilyInstancesFromS3 = async ({
  bimFileId,
  version,
  shouldCache,
}: {
  bimFileId: string;
  version?: string;
  shouldCache?: boolean;
}): Promise<{ [externalId: string]: FamilyInstanceDTO } | undefined> => {
  return getDataFamilyInstance({ bimFileId, version, shouldCache });
};

export const getMapCategoriesProps = async (bimFile: DataProjectModel) => {
  try {
    const urn = GenerateForgeDataHelper.getUrn({
      bimFileId: bimFile.id,
      version: String(bimFile.version),
    });

    const importer = ImportFactory.createImporter(ForgeDataType.CATEGORY_INFO, {
      urn,
    });

    const result = await importer.importData();

    return result?.data;
  } catch (e) {
    return;
  }
};
